module.exports = __webpack_public_path__ + "static/media/unauthentication.6088ed81.svg";